import { TableFormStructure } from '@master/model/structure/FormStructure'
import DependantsProtectionClient from '@master/model/kyc-form/need-analysis/protection/DependantsProtectionClient'
import { YesNoOptions } from '@master/model/options/DefaultOptions'
export function DependantsProtectionStructure (dependantOptions) {
  const structure: TableFormStructure<DependantsProtectionClient> = [
    {
      label: 'Name of Dependant',
      key: 'depName',
      type: 'dropdown',
      classes: ['wrap-select'],
      options: dependantOptions,
      onChange: (oldVal, newVal, depModal) => {
        depModal.disabledInput = false
      },
      clearModelWhenEmpty: {
        alertMessage: 'This will clear the dependant data entry. Proceed?',
        actionConfirm: (oldVal, newVal, depModal) => {
          depModal.disabledInput = true
          depModal.clear()
        },
        actionCancel: (oldVal, newVal, depModal) => {
          depModal.disabledInput = false
        }
      }
    },
    {
      title: 'i. In the Event of Hospitalisation',
      colspan: 6
    },
    {
      label: 'Preferred Hospital Type',
      key: 'preferredHospitalType',
      type: 'dropdown',
      options: [
        { label: '', value: '' },
        { label: 'Public', value: 'public' },
        { label: 'Private', value: 'private' }
      ],
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      label: 'Preferred Ward Type',
      key: 'preferredWardType',
      type: 'dropdown',
      options: [
        { label: '', value: '' },
        { label: 'A', value: 'A' },
        { label: 'B1', value: 'B1' },
        { label: 'B2', value: 'B2' },
        { label: 'C', value: 'C' }
      ],
      disabled: (dependantsProtectionClient) => dependantsProtectionClient.preferredHospitalType === 'private' || dependantsProtectionClient.shouldDisabledInput
    },
    {
      label: 'Rider for Deductible & Co-Insurance',
      key: 'riderDeductible',
      type: 'dropdown',
      options: [{ label: '', value: '' }, ...YesNoOptions],
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      label: 'Existing hospital coverage (Type, ward and coverage)',
      key: 'existingCoverage',
      type: 'textarea',
      rows: 5,
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      title: 'ii. In the Event of Critical Illness',
      colspan: 6
    },
    {
      label: 'Total Funds Required ($)',
      key: 'totalFundsRequired',
      type: 'currency',
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      label: '- Less existing resources (if any) ($)',
      key: 'iiLessExisting',
      type: 'currency',
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      label: '<div class="bold-text">Surplus / <span style="color: darkred">(Shortfall)</span> ($)</div>',
      key: 'criticalIllnessSurplus',
      type: 'currency',
      classes: ['disabled-td'],
      disabled: true
    },
    {
      title: 'iii. In the Event of Disability',
      colspan: 6
    },
    {
      label: 'Annual expenses required ($)',
      key: 'annualExpenses',
      type: 'currency',
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      label: 'Number of years required',
      key: 'yearsRequired',
      type: 'number',
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      label: 'Inflation adjusted rate return (%)',
      key: 'infAdjusted',
      type: 'number',
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      label: 'Lump sum required to maintain lifestyle (PV) ($)',
      key: 'disabilityLumpSum',
      type: 'currency',
      classes: ['disabled-td'],
      disabled: true
    },
    {
      label: '+ Cost of medical treatment ($)',
      key: 'medicalTreatment',
      type: 'currency',
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      label: 'Estimated amount required for disability ($)',
      key: 'disabilityEstimatedAmount',
      type: 'currency',
      classes: ['disabled-td'],
      disabled: true
    },
    {
      label: '- Other funds available ($)',
      key: 'otherFunds',
      type: 'currency',
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      label: '<div class="bold-text">Surplus / <span style="color: darkred">(Shortfall)</span> ($)</div>',
      key: 'disabilitySurplus',
      type: 'currency',
      classes: ['disabled-td'],
      disabled: true
    },
    {
      title: 'iv. In the Event of Death',
      colspan: 6
    },
    {
      label: 'Final Expenses ($)',
      key: 'finalExpenses',
      type: 'currency',
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      label: '+ Loans (eg education loan etc) ($)',
      key: 'loans',
      type: 'currency',
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      label: '+ Others ($)',
      key: 'others',
      type: 'currency',
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      label: 'Total cash needs ($)',
      key: 'deathCashNeeds',
      type: 'currency',
      classes: ['disabled-td'],
      disabled: true
    },
    {
      label: '- Less existing resources (if any) ($)',
      key: 'ivLessExisting',
      type: 'currency',
      disabled: (dep) => { return dep.shouldDisabledInput }
    },
    {
      label: '<div class="bold-text">Surplus / <span style="color: darkred">(Shortfall)</span> ($)</div>',
      key: 'deathSurplus',
      type: 'currency',
      classes: ['disabled-td'],
      disabled: true
    }
  ]
  return structure
}
